import React from 'react'
import './alert.scss'
const Alert = (props) => {
    return (
        <div className='alert_message'>dd</div>
    )
}

export default Alert